import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Product } from '../../api/storeApi';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: Product[];
  loading: boolean;
  error: string | null;
}

export const ProductGrid: React.FC<ProductGridProps> = ({ products, loading, error }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (products.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography>No products found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          display: 'grid',
          gap: { xs: 1, sm: 2 },
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
          px: { xs: 0, sm: 2 },
          py: { xs: 0.5, sm: 2 },
          boxSizing: 'border-box',
        }}
      >
        {products.map((product) => (
          <Box key={product.id} sx={{ height: '100%' }}>
            <ProductCard product={product} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
